var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareViewYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.642578,
    width: 43,
    height: 43,
    rx: 12.2857,
    fill: "url(#paint0_linear_1011_19668)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.911 12.2861H15.1139C12.2108 12.2861 9.85742 14.6396 9.85742 17.5427V24.9397C9.85742 27.8428 12.2109 30.1962 15.1139 30.1962H29.911C32.8141 30.1962 35.1675 27.8428 35.1675 24.9397V17.5427C35.1675 14.6396 32.814 12.2861 29.911 12.2861ZM26.356 21.6011L19.435 24.9019C19.2505 24.9899 19.0374 24.8556 19.0374 24.6513V17.8432C19.0374 17.6359 19.2561 17.5015 19.4408 17.5953L26.3617 21.1025C26.5678 21.2067 26.5641 21.5019 26.356 21.6011Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_19668",
    x1: 22.1426,
    y1: 0,
    x2: 22.1426,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareViewYt);
export default __webpack_public_path__ + "static/media/share-view-yt.bf14bc2098ab0917064caf9d5ee0d48a.svg";
export { ForwardRef as ReactComponent };